import { useState, useEffect } from 'react';
import "./styles/profileInfo.css"

export default function ProfileInfoA() {
    const [profile] = useState(JSON.parse(localStorage.getItem('user_profile')));
    const [aws_JWT] = useState(window.localStorage.getItem('aws_JWT'));
    const [userCoupons, setUserCoupons] = useState([]);

    useEffect(() => {
      getCoupon(aws_JWT);
    },[])

    function getCoupon(aws_JWT) {
      return fetch('https://shopxyz.online/api/1.0/user/coupon', {
          headers: new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${aws_JWT}`,
          }),
          method: 'GET',
      })
      .then((response) => response.json())
      .then((result) => {setUserCoupons(result.sort(function (a, b) {
                                                      return a.amount - b.amount;
                                                  })
                                      ); 
                          return result})
    }

    function couponSource(source){
      if (source === 'game'){
        return '遊戲'
      } else if (source === 'level'){
        return '會員'
      } else {
        return '其他'
      }
    }

    function couponColor(source){
      if (source === 'game'){
        return '#866b56'
      } else if (source === 'level'){
        return '#4d8c82'
      } else {
        return '#866b56'
      }
    }
    
    return (
      <>
        {profile && (
          <div className="profile__content">
            <img src={profile.picture} alt="profile" />
            <div>{profile.name}</div>
            <div>{profile.email}</div>
            
            <ul className='profile__content-coupon-list'>
                  {userCoupons
                      .map((element, index) => (
                        <li key={index} className="profile__content-coupon" style={{backgroundColor: couponColor(element.source)}} data-hover={`來源：${couponSource(element.source)}`}>
                          <div className='coupon-icon'></div>
                          &nbsp;{element.title}
                        </li>
                  ))}
            </ul>
          </div>
        )}
      </>
    );
}
